var exports = {
  "kL": "x8b4e8595--11aacb--container",
  "Qs": "x8b4e8595--11aacb--content",
  "Sl": "x8b4e8595--11aacb--image",
};

module.exports = exports;
